export default {
  //开奖控制
  prizeControl: {
    btn01: 'Thêm',
    btn02: 'Xem',
    btn03: 'Chỉnh sửa',
    btn04: 'Xóa',
    btn05: 'Ngẫu nhiên',
    error01: 'Chắc chắn muốn xóa dòng này chứ',
    error02: 'Chắc chắn muốn xóa dòng đã chọn chứ',
    error03: 'Chọn dữ liệu cần xóa',
    error04: 'Sai định dạng kỳ, vui lòng nhập lại',
    error05: 'Sai định dạng kỳ',
    error06: 'Thời gian bắt đầu kỳ cược không được bé hơn thời gian hiện tại',
    error07: 'Vui lòng điền thông tin đầy đủ',
    form01: 'Thuộc nền tảng',
    form02: 'Kỳ mở thưởng',
    form03: 'Thời gian bắt đầu',
    form04: 'Thời gian thanh toán',
    form05: 'Con số mở thưởng',
    title01: 'Nền tảng',
    title02: 'Kỳ',
    title03: 'Thời gian mở thưởng',
    title04: 'Thời gian kết thúc',
    title05: 'Trạng thái',
    title06: 'Chưa mở thưởng',
    title07: 'Đã thanh toán',
    title08: 'Thời gian cập nhật',
    title09: 'Người thực hiện',
    title10: 'Thao tác',
    title12: 'Tất cả',
    remark01: 'Quy tắc cài đặt kỳ cược: 220101001 tức là năm 22 tháng 1 ngày 1 kỳ 001'
  },
  //游戏胜率配置
  gameWinRateConfig: {
    btn01: 'Chỉnh sửa',
    btn02: 'Hủy',
    btn03: 'Xác nhận',
    btn04: 'Gỡ bỏ',
    btn05: 'Chi tiết',
    formTitle01: 'Tên trò chơi',
    formTitle02: 'Loại hình kiểm soát',
    formTitle03: 'Số lần mở thưởng lại tối đa',
    formTitle04: 'Xác suất mở thưởng lại',
    formTitle05: 'Tiền thắng/ Tiền cược',
    formTitle06: 'Lớn hơn',
    formTitle07: 'Lần',
    formTitle08: 'Phạm vi thắng thua  Thắng thua/Tiền cược',
    formTitle09: 'Trạng thái',
    formTitle10: 'Kiểm soát thắng thua trong game',
    formTitle11: 'Kiểm soát thắng thua người chơi',
    formTitle12: 'Kiểm soát đặt cược thắng thua',
    formTitle13: 'Bật',
    formTitle14: 'Tắt',
    remark01: 'Lưu ý: Phạm vi mở thưởng không khớp cài đặt, sẽ phải mở thưởng lại 1 lần; đều không ',
    error01: 'Điền số lần mở thưởng lại tối đa',
    error02: 'Điền phạm vi thắng thua',
    error03: 'Sai định dạng, chỉ được nhập 2 chữ số thập phân',
    error04: 'Chỉ được phép cài đặt trong khoảng từ -100~99999',
    error05: 'Số tối thiểu không được lớn hơn số tối đa',
    error07: 'Số tối đa không được lớn hơn số tối thiểu',
    error08: 'Điền xác suất mở thưởng lại',
    error09: 'Sai định dạng, giá trị phải lớn hơn 0 và chỉ được nhập 2 chữ số thập phân',
    error10: 'Chỉ được phép cài đặt trong khoảng từ 0~100',
    error11: 'Điền tiền thắng/ tiền cược',
    error12: 'Chỉ được phép cài đặt trong khoảng từ 0~99999',
    label01: 'Danh sách người dùng',
    label02: 'Chắc chắn muốn gỡ bỏ dòng này chứ',
    label03: 'Chắc chắn muốn gỡ bỏ dòng đã chọn chứ',
    label04: 'Thông tin cá nhân',
    label05: 'Thuộc nền tảng',
    label06: 'Thời gian thêm',
    label07: 'Thao tác',
    label08: 'Nền tảng',
    label09: 'Tất cả',
    label10: 'Đã gỡ bỏ',
    label11: 'Vui lòng chọn dữ liệu cần gỡ bỏ',
    label12: 'Trạng thái thay đổi',
    label13: 'Chắc chắn muốn',
    label14: 'Phân loại trò chơi',
    label15: 'Tên trò chơi',
    label16: 'Phạm vi thắng thua/ Xác suất mở thưởng lại/ Bội số',
    label17: 'đến',
    label18: 'Tên tài',
  },
  //滚单
  rollList: {
    btn01: 'Chi tiết',
    btn02: 'Chỉnh sửa',
    btn03: 'Ngẫu nhiên tài',
    btn04: 'Ngẫu nhiên xỉu',
    btn05: 'Ngẫu nhiên',
    btn06: 'Xác nhận',
    btn07: 'Hủy',
    table01: 'Thống kê kiểu cược',
    table02: 'Tên trò chơi',
    table03: 'Kiểu cược',
    table04: 'Số người dùng',
    table05: 'Số đặt cược',
    table06: 'Tiền cược',
    table07: 'Tiền thắng dự tính',
    table08: 'Không có dữ liệu',
    table09: 'Tính theo tiền cược',
    table10: 'Tính theo số người dùng',
    table11: 'Số lần đặt cược',
    table12: 'Thuộc nền tảng',
    table13: 'Kỳ mở thưởng',
    table14: 'Thời gian bắt đầu',
    table15: 'Thời gian thanh toán',
    table16: 'Con số mở thưởng',
    remark01: 'Quy tắc cài đặt kỳ cược: 220101001 tức là năm 22 tháng 1 ngày 1 kỳ 001',
    remark02: 'Kỳ tiếp theo trên nền tảng này đã cài đặt con số mở thưởng：',
    remark03: '，Có muốn thay thế không',
    error01: 'Sai định dạng kỳ cược, vui lòng nhập lại',
    error02: 'Sai số kỳ',
    error03: 'Thời gian bắt đầu kỳ cược không được bé hơn thời gian hiện tại',
    error04: 'Vui lòng điền thông tin đầy đủ',
    error05: 'Cài đặt thành công',
    label01: 'Làm mới trang',
    label02: 'Kỳ hiện tại',
    label03: 'Đang mở thưởng',
    label04: 'Đang đặt cược',
    label05: 'Cài đặt mở thưởng',
    label06: 'Làm mới thủ công',
    label07: '5 giây',
    label08: '10 giây',
    label09: '30 giây',
    label10: '1 phút',
    label11: 'Nền tảng',
    label12: 'Tên tài khoản',
    label13: 'Loại hình trò chơi',
    label14: 'Kỳ',
    label15: 'Tiền cược tối thiểu',
    label16: 'Mã giao dịch',
    label17: 'Trò chơi',
    label18: 'Thời gian cược',
    label19: 'Tỉ lệ cược',
    label20: 'Tổng',
  },
  //用户控制
  userControl: {
    platformCode: 'Thuộc nền tảng',
    account: 'Tên tài khoản',
    userId: 'ID người dùng',
    gameName: 'Trò chơi',
    controlType: 'Loại hình kiểm soát/Trạng thái',
    status: 'Trạng thái kiểm soát',
    remark: "Ghi chú",
    operate: "Thao tác",
    all: "Toàn bộ",
    controlTypeStatus: "Tiền thắng trong game",
    controlTypeStatus2: "Tiền thắng của người chơi",
    controlTypeStatus3: "Tiền thắng đặt cược",

    placeholderPlatformCode: 'Vui lòng chọn nền tảng game',
    placeholderAccount: 'Nhập tên tài khoản',
    placeholderGame: 'Chọn trò chơi',
    placeholderRemark: 'Nhập ghi chú',
    selectLabel: 'Chắc chắn muốn đổi hàng loạt trạng thái người dùng thành:',

  },

}
